import { useWeb3React } from '@web3-react/core'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import { useMemo } from 'react'
import { useQuery } from 'react-query'
import { getApolloClientV2ByChain } from './apollo'
import { ETH_PRICE } from './queries'
import { getBlockFromTimestamp, getPercentChange } from './utils'

// format dayjs with the libraries that we need
dayjs.extend(utc)
dayjs.extend(weekOfYear)

/**
 * Gets the current price  of ETH, 24 hour price, and % change between them
 */
const getEthPrice = async (chainId: number | undefined) => {
  const utcCurrentTime = dayjs()
  const utcOneDayBack = utcCurrentTime.subtract(1, 'day').startOf('minute').unix()

  let ethPrice = 0
  let ethPriceOneDay = 0
  let priceChangeETH = 0

  const client = getApolloClientV2ByChain(chainId)
  if (!chainId || !client) {
    return [ethPrice, ethPriceOneDay, priceChangeETH]
  }

  try {
    const oneDayBlock = await getBlockFromTimestamp(chainId, utcOneDayBack)
    const result = await client.query({
      query: ETH_PRICE(),
      fetchPolicy: 'cache-first',
    })
    const resultOneDay = await client.query({
      query: ETH_PRICE(oneDayBlock),
      fetchPolicy: 'cache-first',
    })
    const currentPrice = result?.data?.bundles[0]?.ethPrice
    const oneDayBackPrice = resultOneDay?.data?.bundles[0]?.ethPrice
    priceChangeETH = getPercentChange(currentPrice, oneDayBackPrice)
    ethPrice = currentPrice
    ethPriceOneDay = oneDayBackPrice
  } catch (e) {
    console.log(e)
  }

  return [ethPrice, ethPriceOneDay, priceChangeETH]
}

export function useEthPrice(): [number | undefined, number | undefined, number | undefined] {
  // const [state, { updateEthPrice }] = useGlobalDataContext()
  // const ethPrice = state?.[ETH_PRICE_KEY]
  // const ethPriceOld = state?.['oneDayPrice']
  // useEffect(() => {
  //   async function checkForEthPrice() {
  //     if (!ethPrice) {
  //       let [newPrice, oneDayPrice, priceChange] = await getEthPrice()
  //       updateEthPrice(newPrice, oneDayPrice, priceChange)
  //     }
  //   }
  //   checkForEthPrice()
  // }, [ethPrice, updateEthPrice])
  //
  // return [ethPrice, ethPriceOld]

  const { chainId } = useWeb3React()

  const { data } = useQuery<[number, number, number]>({
    queryKey: ['eth-price', chainId],
    queryFn: async () => {
      const [newPrice, oneDayPrice, priceChange] = await getEthPrice(chainId)
      return [newPrice, oneDayPrice, priceChange]
    },
    enabled: !!chainId,
  })

  return useMemo(() => data ?? [undefined, undefined, undefined], [data])
}
